/** Quick-filter chips of the Members list, in display order. `''` is "All". */
export const MEMBER_QUICK_FILTERS = Object.freeze([
  { value: '', labelKey: 'members.filters.all' },
  { value: 'active', labelKey: 'terms.status.active' },
  { value: 'invited', labelKey: 'terms.status.invited' },
  { value: 'notInvited', labelKey: 'terms.status.notInvited' },
  { value: 'suspended', labelKey: 'terms.status.suspended' },
  { value: 'removed', labelKey: 'terms.status.removed' },
]);

/** MFA filter values the service understands. */
export const MFA_FILTER = Object.freeze({ ON: 'on', OFF: 'off' });

export const MEMBERS_PAGE_SIZE_OPTIONS = Object.freeze([10, 15, 25, 50]);
export const MEMBERS_DEFAULT_PAGE_SIZE = 10;

/** Sort fields of the list (API names) and their label keys. */
export const MEMBERS_SORT_FIELDS = Object.freeze([
  { value: 'name', labelKey: 'members.columns.member' },
  { value: 'user_type', labelKey: 'members.columns.userType' },
  { value: 'added_at', labelKey: 'members.columns.added' },
  { value: 'last_active_at', labelKey: 'members.columns.lastActive' },
]);

/** The list opens with the most recently added members first. */
export const MEMBERS_DEFAULT_SORT = Object.freeze({ field: 'added_at', direction: 'desc' });

/** Buckets of the Added filter (page state) and the value the service filters by. */
export const ADDED_FILTER = Object.freeze({
  TODAY: 'today',
  LAST_7_DAYS: '7d',
  LAST_30_DAYS: '30d',
  EARLIER: 'earlier',
});

export const ADDED_FILTER_OPTIONS = Object.freeze([
  { value: ADDED_FILTER.TODAY, labelKey: 'members.filters.added.today', api: 'today' },
  { value: ADDED_FILTER.LAST_7_DAYS, labelKey: 'members.filters.added.last7', api: 'last_7_days' },
  { value: ADDED_FILTER.LAST_30_DAYS, labelKey: 'members.filters.added.last30', api: 'last_30_days' },
  { value: ADDED_FILTER.EARLIER, labelKey: 'members.filters.added.earlier', api: 'earlier' },
]);

export const ADDED_FILTER_TO_API = Object.freeze(
  Object.fromEntries(ADDED_FILTER_OPTIONS.map(({ value, api }) => [value, api])),
);

/** Every filter dimension of the bar and the slideout; `status` is the quick-filter chips too. */
export const EMPTY_MEMBERS_FILTERS = Object.freeze({
  status: '',
  role: [],
  group: [],
  mfa: '',
  added: '',
  importBatch: '',
});
